import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
 
 
import { FormControl } from '@angular/forms';
 
import { Observable } from 'rxjs';
import { Client } from 'src/app/entity/exhibitor';
import { ExhibitorService } from 'src/app/service/exhibitor.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-exhibitor-dialog',
    templateUrl: 'exhibitor-dialog.component.html',
    styleUrls: ['./exhibitor-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class ExhibitorDialogComponent {
    title: string;
    message: string;
    exhibitors: Observable<Client[]>;
    exhibitor:Client;
    control=new FormControl();
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private clientService:ExhibitorService) { 


            
        }

    ngOnInit() {
        this.title = this.data.title;
        this.message = this.data.message;
        this.control.valueChanges.subscribe(result=>{
             this.exhibitors=  this.clientService.findClientsByRaison(result) 
        });
    }
    compareFExhibitor(v1: Client, v2: Client): boolean {
        return v1 && v2 ? v1.prospectId.raisonSocial === v2.prospectId.raisonSocial : v1 === v2;
      }
      displayFn(client?: Client): string | undefined {
        return client ? client.prospectId.raisonSocial : "";
      }
    select(exhibitor:Client){
        this.exhibitor=exhibitor;
    }

    onChanges(event)  {


 //console.log("change"+event.value);
 
    
    
      }
}

